import { EntityLinks, Goal, ID } from '@griply/types';

import { canGoalHaveChildren } from './can-goal-have-children';
import { getSubGoals } from './get-sub-goals';

// blocked: the dragged goal, its descendants (no self-nesting), and projects (leaves)
export const getBlockedDropTargetIds = (
  draggedGoalId: ID,
  goals: Goal[],
  links?: EntityLinks,
): Set<ID> =>
  new Set([
    draggedGoalId,
    ...getSubGoals(draggedGoalId, { goals, recursive: true, links }).map(
      ({ id }) => id,
    ),
    ...goals.filter((goal) => !canGoalHaveChildren(goal)).map(({ id }) => id),
  ]);
